<template>
  <div
    :class="['relative', extraClass]"
  >
    <v-select
      :placeholder="placeholder"
      :options="options"
      :components="{OpenIndicator}"
      :value="value"
      :class="[error.length > 0 ? 'error' : '', 'w-full mt-auto']"
      :reduce="reduce"
      :multiple="multiple"
      @input="onInput"
    />
    <span v-if="error" class="inline-flex px-2 py-1 mt-2 text-xs leading-normal text-au_error input-error bg-au_error-100">
      {{ error }}
    </span>
  </div>
</template>

<script>
import Select from '~brand-components/base/select/select'

export default Select.extend()
</script>

<style lang="scss">
.v-select {
  @apply text-lg;

  .vs__dropdown-toggle {
    @apply text-au_blue-600 h-12 py-0 px-4 border border-transparent rounded;
  }

  .vs__selected-options {
    @apply p-0;
  }

  .vs__selected {
    @apply h-12 border-0 rounded-none p-0 m-0;
  }

  .vs__search {
    @apply m-0 p-0;
  }

  .vs__actions {
    @apply p-0 pr-2;
  }

  .vs__open-indicator {
    display: block;
    width: 13px;
    height: 8px;
    background: url('~images/austrian/icons/arrow-down-2.svg') 0 0 / 13px 8px no-repeat;
  }

  .vs__clear {
    @apply hidden;
  }

  .vs__dropdown-menu {
    top: calc(100% + 5px);
    border-top-style: solid !important;

    @apply shadow-none border-au_gray-200 rounded-t-none;
  }

  .vs__dropdown-option {
    @apply leading-none p-3 text-au_gray-700 text-base;
  }

  .vs__dropdown-option--highlight {
    @apply bg-au_primary_hover text-white;
  }

  .vs__dropdown-option--selected {
    @apply bg-au_primary_hover text-white;
  }

  &.vs--open {
    .vs__dropdown-toggle {
      @apply border-au_gray-200;
    }

    .vs__selected {
      @apply top-0 left-0;
    }
  }

  &.error {
    .vs__dropdown-toggle {
      @apply text-au_error;
    }
  }
}
</style>
